<script>
  import { surveyStore } from '../../stores/surveyStore.js';
  import { GA4Events } from '../../services/api.js';
  
  function handleStart() {
    GA4Events.surveyStarted();
    surveyStore.goToScreen('q1', 1);
  }
</script>

<div class="card">
  <div class="card-eyebrow">Season Ticket Membership</div>
  <h1 class="card-title">What is a Cleveland Sirens Ticket <em>Membership?</em></h1>
  <div class="card-body">
    <p>A Season Ticket Membership is your season-long seat at Cleveland's WNBA team — every home game, or a flexible half-season schedule built around your life. Your <strong>$28 Initial Payment per seat</strong> holds your priority in line: the sooner you place it, the better your seats when selection opens in Spring 2027.</p>
    <p>Your Initial Payment secures your priority position for seat selection — the earlier you're in, the better your seats in Spring 2027. Full membership benefits will be introduced closer to the inaugural season.</p>
    <p>Answer a few quick questions and we'll match you with the membership that fits how you want to show up.</p>
  </div>
  <button class="cta-primary" on:click={handleStart}>
    Get started →
  </button>
</div>
